module.exports = __webpack_public_path__ + "img/chain09.04fbf2ea.png";